export default "__VITE_ASSET__cb1a8917__"